import axios from "axios";
import Swal from "sweetalert2";
import { EXPRESS_BASE_URL } from "./apiConfig";

// Ogrenci ilk kez giris yaptiginda (StudentResponsibility tablosunda kaydi
// yoksa) uyelik turunu sormadan hicbir sayfada islem yapilmasina izin
// vermiyoruz: bu fonksiyon login akisinda setUser/redirect'ten ONCE await
// edilerek kayit olusana kadar akisi burada bekletiyor.
export const ensureStudentResponsibility = async (userData) => {
    const userInfo = userData?.user || userData?.User;
    const userDetail = userData?.detail || userData?.Detail;

    if (!userInfo || userInfo.roleName !== "Student") return;

    try {
        const checkRes = await axios.get(
            `${EXPRESS_BASE_URL}/getstudentresponsibilitybyuserid/${userInfo.id}`
        );
        if (Array.isArray(checkRes.data) && checkRes.data.length > 0) return;
    } catch (err) {
        console.error("Sorumluluk kaydi kontrol edilirken hata olustu:", err);
        return;
    }

    let saved = false;
    while (!saved) {
        const result = await Swal.fire({
            title: "Üyelik Türü",
            text: "Devam edebilmek için lütfen üyelik türünüzü seçiniz.",
            icon: "question",
            showDenyButton: true,
            showConfirmButton: true,
            showCancelButton: false,
            showCloseButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            reverseButtons: true,
            confirmButtonText: "Kendisi",
            denyButtonText: "Velayeti/Vesayeti Altında olan Çocuk",
        });

        const type = result.isConfirmed ? 0 : 1;

        try {
            await axios.post(`${EXPRESS_BASE_URL}/poststudentresponsibility`, {
                userid: userInfo.id,
                name: userInfo.fullName,
                email: userInfo.username,
                type: type,
                onay: 1,
                schoolid: userDetail?.schoolId || 0,
                classid: userDetail?.classId || 0,
            });
            saved = true;
        } catch (err) {
            await Swal.fire({
                title: "Hata",
                text: "Kaydınız oluşturulamadı, lütfen tekrar deneyiniz.",
                icon: "error",
                confirmButtonText: "Tamam",
            });
        }
    }
};
